import React, { useEffect, useState } from "react";
import Topbar from "../../topbar/Topbar";
import {
  TextVariant,
  TypographyNew,
} from "../../../product/global/typography/typography";
import { MainContainer, ResponsiveContainer } from "../../welcome/Welcome";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/pro-solid-svg-icons";
import LinkStyled from "../../../product/global/buttonsLinks/LinkStyled";
import Footer from "../../footer/Footer";
import { AbsenceRequestView } from "../../../product/redux/api-model/employees/absence";
import { useParams } from "react-router-dom";
import { CoreRequest } from "../../../product/redux/config/serviceInstances";
import CenteredLoadingIndicator from "../../../product/global/loading/CenteredLoadingIndicator";
import StatusChip from "../../../product/global/common/StatusChip";
import ConditionalRender from "../../../product/accounts/company/pages/sv/components/ConditionalRender";
import i18next from "i18next";
import { ApprovalStatus } from "../../../product/redux/api-model/employees/approval-statuses";

const InlineRow = styled.div`
  display: inline-flex;
  align-items: center;
`;

const Container = styled.div`
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const GridStyled = styled.div`
  display: grid;
  grid-template-columns: 0.7fr 1.5fr;
  grid-gap: 10px;
  margin-bottom: 40px;
`;

function answer(r: RequestStatus): JSX.Element {
  if (r.loading) {
    return <CenteredLoadingIndicator />;
  }
  if (r.error) {
    return (
      <>
        <FontAwesomeIcon icon={faTimesCircle} color={"red"} size={"2x"} />
        <InlineRow>
          <TypographyNew
            variant={TextVariant.h5}
            marginTop={"40px"}
            marginBottom={"40px"}
            marginLeft={"10px"}
          >
            {i18next.t("absence.notUpdated")}
          </TypographyNew>
        </InlineRow>
      </>
    );
  }
  if (r.data && !r.error) {
    return (
      <>
        <FontAwesomeIcon icon={faCheckCircle} color={"darkgreen"} size={"2x"} />
        <InlineRow>
          <TypographyNew
            variant={TextVariant.h5}
            marginTop={"40px"}
            marginBottom={"40px"}
            marginLeft={"10px"}
          >
            {i18next.t("absence.updated")}
          </TypographyNew>
        </InlineRow>
      </>
    );
  }
  return <></>;
}

enum QuickAction {
  APPROVE = "approve",
  REJECT = "reject",
}

interface QuickActionsUrlParams {
  secureId: string;
  resourceId: string;
  action: QuickAction;
}

interface RequestStatus {
  loading: boolean;
  error: boolean;
  data?: AbsenceRequestView;
}

const QuickActions = (): JSX.Element => {
  const [state, setState] = useState<RequestStatus>({
    loading: false,
    error: false,
    data: undefined,
  });

  const { secureId, resourceId, action } = useParams<QuickActionsUrlParams>();

  useEffect(() => {
    setState({ ...state, loading: true });
    CoreRequest.put(`/quick-action/${secureId}/${resourceId}/${action}`, null, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((r) => {
        setState({ error: false, loading: false, data: r.data });
      })
      .catch(() => {
        setState({ error: true, loading: false });
      });
  }, [secureId, resourceId, action]);

  return (
    <>
      <Topbar />
      <MainContainer>
        <ResponsiveContainer>
          <Container>
            {answer(state)}
            <ConditionalRender condition={state.data != undefined}>
              <GridStyled>
                <TypographyNew variant={TextVariant.body1}>
                  {i18next.t("employee")}
                </TypographyNew>
                <div>
                  <TypographyNew variant={TextVariant.subtitle2}>
                    {state.data?.employeeDto.firstName}{" "}
                    {state.data?.employeeDto.lastName}
                  </TypographyNew>
                </div>
                <TypographyNew variant={TextVariant.body1}>
                  {i18next.t("timeframe")}
                </TypographyNew>
                <TypographyNew
                  variant={TextVariant.subtitle2}
                  marginRight={"5px"}
                >
                  {state.data?.startDate} &nbsp;
                  <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon>
                  &nbsp; {state.data?.endDate}
                </TypographyNew>

                <TypographyNew variant={TextVariant.body1}>
                  {i18next.t("type")}
                </TypographyNew>
                <div>
                  <TypographyNew variant={TextVariant.subtitle2}>
                    {state.data?.absencetype.displayName}
                  </TypographyNew>
                </div>
                <TypographyNew variant={TextVariant.body1}>
                  Status
                </TypographyNew>
                <div>
                  <StatusChip
                    status={
                      state.data
                        ? state.data.approvalStatus
                        : ApprovalStatus.DRAFT
                    }
                  />
                </div>
              </GridStyled>
            </ConditionalRender>
            <LinkStyled to={"/app/login"}>{i18next.t("to.login")}</LinkStyled>
          </Container>
        </ResponsiveContainer>
      </MainContainer>
      <Footer />
    </>
  );
};

export default QuickActions;
